import React, { createContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "@frontegg/react";
import useAppStore from "src/stores/appStore";

const SocketContext = createContext(null);
const SERVER_DISCONNECT = "io server disconnect";

const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { user } = useAuth();
  const isAuthenticated = !!user?.accessToken;
  useEffect(() => {
    if (!isAuthenticated) {
      setSocket(null);
      return () => {};
    }

    const serverUrl = import.meta.env.VITE_DASHBOARD_API_URL;
    const options = {
      auth: (cb) => cb({ token: useAppStore.getState().accessToken }),
      transports: ["websocket"]
    };

    const newSocket = io(serverUrl, options);
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
      setSocket(null);
    };
  }, [isAuthenticated]);

  useEffect(() => {
    if (!socket) return;

    const handleDisconnect = (reason) => {
      if (reason === SERVER_DISCONNECT) {
        socket.connect();
      }
    };

    socket.on("disconnect", handleDisconnect);
    return () => socket.off("disconnect", handleDisconnect);
  }, [socket]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export { SocketProvider, SocketContext };
